// EmailJS Configuration
// You need to set up EmailJS account and get these values from https://www.emailjs.com/

export const EMAILJS_CONFIG = {
  // Replace with your EmailJS service ID
  SERVICE_ID: 'service_ge577ty',
  
  // Replace with your EmailJS template ID for contact form
  CONTACT_TEMPLATE_ID: 'template_t50vc3n',
  
  // Replace with your EmailJS template ID for service applications
  SERVICE_TEMPLATE_ID: 'template_2m9qy1g',
  
  // Replace with your EmailJS public key
  PUBLIC_KEY: 'bcwi04bMt9dkptWWd',
  
  // Your email address where emails will be sent
  TO_EMAIL: 'ontimestaff1@gmail.com'
};

// Instructions for setting up EmailJS:
// 1. Go to https://www.emailjs.com/ and create an account
// 2. Create a new service (Gmail, Outlook, etc.)
// 3. Create email templates for:
//    - Contact form: template_ontimestaff_contact
//    - Service applications: template_service_application
// 4. Get your public key from the account settings
// 5. Replace the values above with your actual EmailJS configuration
// 6. Update the emailService.ts file with the correct template IDs

// Email template variables for contact form:
// - {{to_email}} - Your email address
// - {{from_name}} - Sender's name
// - {{from_email}} - Sender's email
// - {{company}} - Sender's company
// - {{phone}} - Sender's phone
// - {{service}} - Selected service
// - {{message}} - Message content
// - {{reply_to}} - Reply-to email

// Email template variables for service applications:
// - {{to_email}} - Your email address
// - {{service_name}} - Name of the service
// - {{applicant_name}} - Applicant's name
// - {{applicant_email}} - Applicant's email
// - {{applicant_phone}} - Applicant's phone
// - {{company}} - Applicant's company
// - {{message}} - Additional message
// - {{from_name}} - Applicant's name
// - {{reply_to}} - Applicant's email

// Email template variables for job applications:
// - {{to_email}} - Your email address
// - {{job_title}} - Title of the job position
// - {{applicant_name}} - Applicant's name
// - {{applicant_email}} - Applicant's email
// - {{applicant_phone}} - Applicant's phone number
// - {{resume}} - Applicant's resume/CV
// - {{position_type}} - Full-time or Part-time
// - {{cover_letter}} - Cover letter or additional information
// - {{from_name}} - Applicant's name
// - {{reply_to}} - Applicant's email
